var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 63.067 63.067" },
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        version: "1.1",
        id: "Capa_1",
        x: "0px",
        y: "0px",
        width: "24",
        height: "24",
        viewBox: "0 0 63.067 63.067",
        "xml:space": "preserve"
      }
    },
    [
      _c("g", [
        _c("path", {
          attrs: {
            d:
              "M34.028,27.406l14.614-13.003L35.733,29.177c0.393,0.7,0.637,1.496,0.637,2.356c0,2.674-2.168,4.836-4.838,4.836   c-2.672,0-4.837-2.162-4.837-4.836c0-2.672,2.165-4.837,4.837-4.837C32.452,26.696,33.297,26.964,34.028,27.406z M63.067,31.533   c0,17.387-14.146,31.534-31.533,31.534C14.147,63.067,0,48.92,0,31.533C0,14.146,14.147,0,31.534,0   C48.921,0,63.067,14.146,63.067,31.533z M56.163,42.228l-3.963-1.61l0.464-1.146l3.948,1.608c0.994-2.604,1.588-5.396,1.72-8.311   h-4.233v-2.471h4.233c-0.139-3.03-0.767-5.926-1.834-8.615l-3.935,1.656l-0.479-1.138l3.936-1.656   c-2.742-6.084-7.669-10.973-13.794-13.643l-1.612,3.963l-1.141-0.464l1.607-3.948c-2.598-0.996-5.398-1.588-8.313-1.722v4.235   h-2.466V4.732c-3.03,0.138-5.926,0.769-8.614,1.834l1.656,3.934l-1.138,0.479l-1.656-3.934c-2.613,1.177-4.995,2.764-7.086,4.672   l2.989,2.989l-1.745,1.745l-2.989-2.989c-1.981,2.169-3.624,4.65-4.814,7.378l3.963,1.611l-0.464,1.143l-3.947-1.607   c-0.996,2.602-1.589,5.396-1.722,8.311h4.235v2.467H4.733c0.138,3.031,0.769,5.926,1.834,8.615l3.934-1.656l0.479,1.139   L7.046,42.52c1.177,2.613,2.763,4.995,4.671,7.085l2.989-2.988l1.745,1.745l-2.989,2.985c4.776,4.361,11.109,7.051,18.072,7.051   c6.962,0,13.289-2.68,18.07-7.051l-2.988-2.985l1.745-1.745l2.986,2.988C53.332,47.438,54.975,44.955,56.163,42.228z    M22.625,48.368h17.819v-3.504H22.625V48.368z"
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }